import { useEffect } from 'react';

import styled from '@emotion/styled';

import { pcProductDetailStyles } from '../../../../../../styles/product/pcGoodsDetail.css';
import { handleCertification, handlePCTestReport } from '../../../shared/utils/productDetailDescription';
import RawHTML from '../../../../../shared/components/layouts/RawHTML';

const Container = styled.div`
  width: 100%;
`;

interface Props {
  legacyContent: string;
}

export default function InformationContents({ legacyContent }: Props) {
  useEffect(() => {
    const testReportElement = document.querySelector<HTMLElement>('.inner_certify');
    const certificationElement = document.querySelector<HTMLElement>('.certification_area');

    if (testReportElement) {
      handlePCTestReport(testReportElement);
    }

    if (certificationElement) {
      handleCertification(certificationElement);
    }
  }, []);

  return (
    <Container>
      <RawHTML css={pcProductDetailStyles} html={legacyContent} />
    </Container>
  );
}
